// removed by extract-text-webpack-plugin
module.exports = {"form":"form___Hn9mp","loading":"loading___3onYg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/index.scss
// module id = 82
// module chunks = 0